<script setup>
import TimetableDiff from './TimetableDiff.vue';
</script>
<template>
    <div class="historical-timetables">
        <h1>Historical timetables</h1>
        <table>
            <tr v-for="timetable, idx in timetables" :key="idx"
                :class="{ 'historical-timetbles-active-row': timetable.lastModifiedDateTime === activeTimetableModified }">
                <td>{{ formatDate(timetable.lastModifiedDateTime) }}</td>
                <td>
                    <button class="button" @click="load(timetable)" :disabled="busy">Load</button>
                    <button class="button" @click="compare(idx)" :disabled="busy"
                        v-if="idx < timetables.length - 1">Compare</button>
                </td>
            </tr>
        </table>
        <div v-if="comparing" class="historical-timetables-status">Comparing…</div>
        <div v-if="diffError" class="historical-timetables-error">{{ diffError }}</div>
        <button class="button" @click="getTimetables()" v-if="nextLink" :disabled="busy">Load more...</button>

        <timetable-diff v-if="showDiff && diff" :older="diff.older" :newer="diff.newer" :older-date="diff.olderDate"
            :newer-date="diff.newerDate" @close="showDiff = false" />
    </div>
</template>
<script>
import FileFetcher from '@/FileFetcher';
import loadEverything from '@/loadEverything';
import moment from 'moment';
import { graphClient } from '@/login';
import { sortBy } from '@/utility.js';
import config from '@/config';
import router from '@/router';

export default {

    data() {
        return {
            timetables: [],
            loading: false,
            comparing: false,
            nextLink: null,
            showDiff: false,
            diff: null,
            diffError: null,
        }
    },
    methods: {
        formatDate(date) {
            return moment(date).format('ddd D MMM YYYY h:mm A')
        },
        async getTimetables() {
            var graph_endpoint;
            if(this.nextLink) {
                graph_endpoint = this.nextLink;
            } else {
                graph_endpoint = `https://graph.microsoft.com/v1.0/drives/${config.SHAREPOINT_DRIVE_ID}/root:/Speedy/${config.SPEEDY_VERSION}:/children?$orderby=name desc`;

            }
            var folder = await graphClient
                .api(graph_endpoint)
                .get();
            var files = folder.value
            files = files.filter(file => /\.json$/.test(file.name));
            files.sort(sortBy(file => file.lastModifiedDateTime, { reverse: true }));

            if(folder['@odata.nextLink']) {
                this.nextLink = folder['@odata.nextLink'];
            } else {
                this.nextLink = null;
            }

            this.timetables.push(...files);
        },
        async download(file) {
            var resp = await fetch(file['@microsoft.graph.downloadUrl']);
            return await resp.json();
        },
        async load(latestFile) {
            this.loading = true;
            this.timetable_data = await this.download(latestFile);
            FileFetcher.lastModifiedDateTime = latestFile.lastModifiedDateTime;
            loadEverything(this.timetable_data);
            var path = router.currentRoute.value.fullPath;
            await router.push('/');
            await router.push(path);
            this.loading = false;
        },
        async compare(idx) {
            var newerFile = this.timetables[idx];
            var olderFile = this.timetables[idx + 1];
            this.diffError = null;
            if (!olderFile) {
                this.diffError = 'There is no older timetable to compare against.';
                return;
            }
            this.comparing = true;
            try {
                var [newer, older] = await Promise.all([
                    this.download(newerFile),
                    this.download(olderFile),
                ]);
                this.diff = {
                    newer,
                    older,
                    newerDate: newerFile.lastModifiedDateTime,
                    olderDate: olderFile.lastModifiedDateTime,
                };
                this.showDiff = true;
            } catch (e) {
                console.error('Could not compare timetables', e);
                this.diffError = 'Could not download the timetables to compare.';
            } finally {
                this.comparing = false;
            }
        },
    },
    computed: {
        busy() {
            return this.loading || this.comparing;
        },
        activeTimetableModified() {
            return FileFetcher.lastModifiedDateTime;
        }
    },
    mounted() {
        this.getTimetables();
        document.body.style.marginRight = '400px';
    },
    unmounted() {
        document.body.style.marginRight = null;
    }
}
</script>
<style>
.historical-timetbles-active-row {
    background: #5252bb;
    color: white;
}

.historical-timetables {
    position: fixed;
    bottom: 0px;
    right: 0px;
    top: 0px;
    overflow-y: scroll;
    background: white;
    width: 400px;
}

.historical-timetables-status {
    padding: 4px 8px;
    font-style: italic;
    color: #555;
}

.historical-timetables-error {
    padding: 4px 8px;
    color: #b3261e;
}
</style>
